export const CAMEL_QUERY_KEY_NAMESPACE = 'camel'

export const CAMEL_DEFAULT_STALE_TIME = 5 * 60 * 1000
